import { APIModel } from '@/src/models/api-model';
import { ItemType } from './item-type';
import { AssociatedUser } from '../../associated-user';

export class Item extends APIModel {
  id: string;
  item_body: string;
  checklist_template_id: string;
  disabled_at: string;
  item_type: ItemType;
  created_by: AssociatedUser;
  updated_by: AssociatedUser;
  disabled_by: AssociatedUser;
  state: string;

  static fieldsToMap = {
    direct: [
      'id',
      'item_body',
      'disabled_at',
      'checklist_template_id'
    ]
  }

  static buildFromAPI(record: any): Item {
    const row = new Item();
    record = record || {};

    this.mapFieldsDirectly<Item>(Item.fieldsToMap.direct, record, row);
    row.item_type = ItemType.buildFromAPI(record.item_type);
    row.created_by = AssociatedUser.buildFromAPI(record.created_by);
    row.updated_by = AssociatedUser.buildFromAPI(record.updated_by);
    row.disabled_by = AssociatedUser.buildFromAPI(record.disabled_by);
    row.state = row.disabled_at ? 'Disabled' : 'Enabled'

    return row
  }
}